import React from 'react';
import styled from 'styled-components';
import {SaveFilterButton} from './SaveFilterButton';
import {YourFiltersButton} from './YourFiltersButton';
import {usePersonalizedFiltersDropdown} from './utils/usePersonalizedFiltersDropdown';
import {
  PersonalizedFilterStore,
  usePersonalizedFiltersStore,
} from './utils/usePersonalizedFiltersStore';

export const PersonalizedFilters: React.FC<PersonalizedFilterStore> = ({
  appliedFiltersData,
  categoryName,
}) => {
  const {
    isYourFiltersDropdownOpen,
    openYourFiltersDropdown,
    closeYourFiltersDropdown,
    showSavedSuccessMessage,
  } = usePersonalizedFiltersDropdown();

  const {
    personalizedFilters,
    savePersonalizedFilter,
    currentFilterCombinationAlreadyExists,
    deletePersonalizedFilter,
    appliedPersonalizedFilterId,
  } = usePersonalizedFiltersStore({
    appliedFiltersData,
    categoryName,
  });

  return (
    <Wrapper data-testid="personalizedFilters">
      <YourFiltersButton
        isDropdownOpen={isYourFiltersDropdownOpen}
        openDropdown={openYourFiltersDropdown}
        closeDropdown={closeYourFiltersDropdown}
        showSuccessMessage={showSavedSuccessMessage}
        personalizedFilters={personalizedFilters || []}
        deletePersonalizedFilter={deletePersonalizedFilter}
        appliedPersonalizedFilterId={appliedPersonalizedFilterId}
      />
      <SaveFilterButton
        openYourFiltersDropdown={openYourFiltersDropdown}
        isYourFiltersDropdownOpen={isYourFiltersDropdownOpen}
        currentFilterCombinationAlreadyExists={
          !!currentFilterCombinationAlreadyExists
        }
        savePersonalizedFilter={savePersonalizedFilter}
      />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  margin-bottom: 2rem;
`;
